// Lightbox para visualização de fotos
(function() {
    var modal = document.getElementById('lightbox-modal');
    if (!modal) return;

    var modalImg = document.getElementById('lightbox-img');
    var captionText = document.getElementById('lightbox-caption');
    var currentPhotoIndex = 0;
    var currentAlbum = null;

    modalImg.style.transition = "none";
    modalImg.style.opacity = "1";

    function closeModal() {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
        modalImg.src = '';
        captionText.textContent = '';
    }

    var closeBtn = document.querySelector('.lightbox-close');
    if (closeBtn) closeBtn.onclick = closeModal;

    modal.onclick = function(event) {
        if (event.target === modal) closeModal();
    };

    document.addEventListener('keydown', function(event) {
        if (modal.style.display === 'none' || !currentAlbum) return;

        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            navigate(-1);
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            navigate(1);
        } else if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
        }
    });

    function navigate(direction) {
        if (!currentAlbum) return;
        currentPhotoIndex = (currentPhotoIndex + direction + currentAlbum.photos.length) % currentAlbum.photos.length;
        showPhoto();
    }

    var prevBtn = document.querySelector('.lightbox-prev');
    if (prevBtn) prevBtn.onclick = function() { navigate(-1); };

    var nextBtn = document.querySelector('.lightbox-next');
    if (nextBtn) nextBtn.onclick = function() { navigate(1); };

    function showPhoto() {
        if (!currentAlbum || !currentAlbum.photos || !currentAlbum.photos[currentPhotoIndex]) {
            return;
        }
        var photo = currentAlbum.photos[currentPhotoIndex];
        modalImg.src = "";

        captionText.textContent = "Carregando...";

        setTimeout(function() {
            modalImg.src = photo.src;

            modalImg.onload = function() {
                captionText.textContent = photo.caption || '';
            };
        }, 10);
    }

    modal.style.display = 'none';

    window.openLightbox = function(index, album) {
        if (!album) return;
        currentAlbum = album;
        currentPhotoIndex = index;

        modalImg.src = '';

        modal.style.display = 'flex';
        modal.style.alignItems = 'center';
        modal.style.justifyContent = 'center';
        modal.style.flexDirection = 'column';
        modal.style.gap = '12px';
        modal.scrollTop = 0;
        document.body.style.overflow = 'hidden';
        showPhoto();
    };
})();
